import axios from 'axios';

const api = axios.create({ baseURL: import.meta.env.VITE_API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const importTrips = async (file: File, dryRun: boolean = true) => {
  const base64 = await fileToBase64(file);
  const { data } = await api.post('/api/admin/import/trips', { fileBase64: base64, dryRun });
  return data;
};

export const importExpenses = async (file: File, dryRun: boolean = true) => {
  const base64 = await fileToBase64(file);
  const { data } = await api.post('/api/admin/import/expenses', { fileBase64: base64, dryRun });
  return data;
};

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
